import React, { useState, useEffect } from 'react';
import Title from '../../components/common/Title';
import { useTranslation } from 'react-i18next';
import Screen from '../../components/common/Screen';
import Button from '../../components/elements/Button';
import Icon from '../../components/common/Icon';
import Left from '../../components/css/Left';
import { Link, useNavigate } from 'react-router-dom';
import InputField from '../../components/forms/InputField';
import { fetchUserInfo, teamPhoto } from '../../utils';
import Card from '../../components/elements/Card';
import Image from '../../components/images/Image';

const Page = () => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserInfo('/crew-teams', setUserInfo, setLoading, setError, []);
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const scoreTeam = (teamId) => {
    sessionStorage.setItem('otherTeamId', teamId);
  };

  const teams = [
    ...(userInfo?.unclaimed || []),
    ...(userInfo?.claimed || []),
    ...(userInfo?.teams || []),
  ];

  const uniqueTeams = teams.filter(
    (team, index, array) => index === array.findIndex((item) => item.id === team.id)
  );

  const filteredTeams = uniqueTeams.filter((team) => {
    const name = (team.name || '').toLowerCase();
    const teamNumber = String(team.team_number || '').toLowerCase();
    return name.includes(searchQuery) || teamNumber.includes(searchQuery);
  });

  return (
    <Screen p="3">
      <div className="top">
        <Title>{t('scoreATeam')}</Title>

        {uniqueTeams.length > 0 && (
          <div className="justify-content-center">
            <div className="row align-items-center">
              <div className="col-1" style={{ marginTop: '-0.7rem' }}>
                <Icon name="search" />
              </div>

              <div className="col-11">
                <InputField
                  placeholder={t('searchTeams')}
                  name="searchTeams"
                  value={searchQuery}
                  onChange={handleSearchChange}
                >
                  <Icon name="users" />
                </InputField>
              </div>
            </div>
          </div>
        )}

        {userInfo && filteredTeams.length > 0 && (
          <div className="justify-content-center">
            <hr className="mb-2" />
            <Left>
              <Title heading="6" my="2" className="mt-2">
                {t('teams')} ({filteredTeams.length})
              </Title>
            </Left>

            {filteredTeams.map((team) => (
              <div className="dropdown" key={team.id}>
                <Button
                  p="1"
                  mb="1"
                  theme="light"
                  dataBsToggle="dropdown"
                  ariaExpanded={false}
                >
                  <div className="row">
                    <div className="col-2 d-flex align-items-center">
                      <Image
                        url={teamPhoto(team.photo_url, team.company_picture)}
                        size="3rem"
                        className="circle mb-1"
                        reload={true}
                      />
                    </div>
                    <div className="col-9 d-flex align-items-center">
                      <Left>
                        <b>{team.name}</b>
                        {team.team_number && (
                          <span className="badge text-bg-primary ms-2">
                            Table #{team.team_number}
                          </span>
                        )}
                      </Left>
                    </div>

                    <div className="col-1 d-flex align-items-center">
                      <Icon
                        name="menu-dots-vertical"
                        theme="secondary"
                        style={{ marginLeft: '-0.8rem' }}
                      />
                    </div>
                  </div>
                </Button>

                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={() => scoreTeam(team.id)}
                      to='/crew-score-team'
                    >
                      <Icon
                        name="check-circle"
                        className="me-1"
                        theme="primary"
                      />
                      {t('scoreThisTeam')}
                    </Link>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        )}

        {userInfo && uniqueTeams.length === 0 && (
          <div className="justify-content-center mt-3">
            <Card p="3">
              <Title heading="6">{t('noTeamsToClaim')}</Title>
            </Card>
          </div>
        )}
      </div>
    </Screen>
  );
};

export default Page;
